(function ($) {
    $(document).ready(function () {
        /* Show hide US news Summary */
        //$(".press-release__show-more").hide();
        //$(".press-release__more").show();
        $(".page-item a").each(function(){
            var $this = $(this);       
            var _href = $this.attr("href"); 
            $this.attr("href", _href + '&iframe=true');
        })
        $(".icon-plus").hide();
        $('.press-release__more').click(function () {
            if ($(this).parent("td").parent("tr").next().find('.press-release__show-more').is(":visible")) {
                $(this).find(".icon-minus").hide();
                $(this).find(".icon-plus").show();
                $(this).parent("td").parent("tr").next().find('.press-release__show-more').hide();
            } else {
                $(this).find(".icon-minus").show();
                $(this).find(".icon-plus").hide();
                $(this).parent("td").parent("tr").next().find('.press-release__show-more').show();
            }
        });
        $('.events__more').click(function () {
            if ($(this).parent("td").parent("tr").next().find('.events__show-more').is(":visible")) {
                $(this).find(".icon-minus").hide();
                $(this).find(".icon-plus").show();
                $(this).parent("td").parent("tr").next().find('.events__show-more').hide();
            } else {
                $(this).find(".icon-minus").show();
                $(this).find(".icon-plus").hide();
                $(this).parent("td").parent("tr").next().find('.events__show-more').show();
            }
        });
        $('.custom-news__more').click(function () {
            if ($(this).parent("td").parent("tr").next().find('.custom-news__show-more').is(":visible")) {
                $(this).find(".icon-minus").hide();
                $(this).find(".icon-plus").show();
                $(this).parent("td").parent("tr").next().find('.custom-news__show-more').hide();
            } else {
                $(this).find(".icon-minus").show();
                $(this).find(".icon-plus").hide();
                $(this).parent("td").parent("tr").next().find('.custom-news__show-more').show();
            }
        });

        if ($('.custom-news__more').parent("td").parent("tr").next().find('.custom-news__show-more').is(":visible")) {
            $('.custom-news__more').find(".icon-minus").hide();
            $('.custom-news__more').find(".icon-plus").show();
            $('.custom-news__more').parent("td").parent("tr").next().find('.custom-news__show-more').hide();
        }

        $('#contact-form__id').validationEngine('attach', {
            promptPosition: "bottomRight",
            scroll: true,
            onValidationComplete: function(form, status){
                if (!status) {
                    // alert('NOT valid');
                    return false;
                } else {
                    // alert('SURE valid');
                    grecaptcha.execute();
                }
            }
        });

        /* SEC Filing */
        var latestYearSelected = '';
        var earliestYearSelected = '';

        $("#secFilterForm input[type='checkbox']").on("change", function() {

            if (this.id != "undefined" && this.checked) {
                /* year filters */
                if (this.id === "secFilterAllYears") {
                    $("#secFilterForm input[id='secFilterCurrentForms']").prop("checked", false);
                    $("#secFilterForm input[attr='secFilterSingleYear']").prop("checked", true);
                }
                if (this.id === "secFilterCurrentForms") {
                    $("#secFilterForm input[attr='secFilterSingleYear']").prop("checked", true);
                    $("#secFilterForm input[name='categories']").prop("checked", true);
                    // $("#secFilterForm #items").val('50').prop('disabled', true);
                }
                /* form filters */
                if (this.id === "secFilterAllCategories") {
                    $("#secFilterForm input[name='categories']").prop("checked", true);
                }
            }

            if (this.id != "undefined" && !this.checked) {
                /* year filters */
                if (this.id === "secFilterAllYears") {
                    $("#secFilterForm input[attr='secFilterSingleYear']").prop("checked", false);
                }
                if (this.getAttribute('attr') === 'secFilterSingleYear') {
                    $("#secFilterForm input[id='secFilterAllYears']").prop("checked", false);
                    $("#secFilterForm input[id='secFilterCurrentForms']").prop("checked", false);
                }
                // if (this.id === "secFilterCurrentForms") {
                //     $("#secFilterForm #items").prop('disabled', false);
                // }
                /* form filters */
                if (this.id === "secFilterAllCategories") {
                    $("#secFilterForm input[name='categories']").prop("checked", false);
                }
                if (this.getAttribute('attr') === "secFilterFormType") {
                    $("#secFilterForm input[id='secFilterAllCategories']").prop("checked", false);
                }
            }

            /* frontend reflects backend query where first and last date count - rest is filled in */
            /*
            latestYearSelected = $("#secFilterForm input[attr='secFilterSingleYear']:checked").first().prop("disabled", false);
            earliestYearSelected = $("#secFilterForm input[attr='secFilterSingleYear']:checked").last().prop("disabled", false);

            $("#secFilterForm input[attr='secFilterSingleYear']").each(function () {
                if (this.value > earliestYearSelected[0].value && this.value < latestYearSelected[0].value) {
                    $(this).prop("checked", true);
                    $(this).prop("disabled", true);
                }
            });
            */
        });

        // Calendar View Events
        $( "#datepicker,#datepickerStart,#datepickerEnd" ).datepicker({
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
            dateFormat: 'yy-mm-dd'
            // onSelect: function (date) {
            //     getEvents(date);
            // }
        });


     


        $("#show_events").on("click", "div.date", function() {
            var date = $(this).data("date");
            $("#datepicker").datepicker("setDate", date);
        });
        $(".custom-tooltip").hide();
        $("html").on("mouseenter",".ui-datepicker-calendar td", function(event) {
            var day   = $(this).text();
            var month = $(this).data('month')+1;
            var year  = $(this).data('year');
            var getDate = new Date(year+"/"+month+"/"+day);
            createCustomTooltip(event, getDate);
        });
        $('.ui-datepicker-calendar tbody').hover(function(){
            $(".custom-tooltip").fadeIn('fast');
        }, function() {
            $(".custom-tooltip").fadeOut('fast');
        });
        // $('#datepicker').on('mouseout', '.ui-datepicker-calendar', function() {
        //     if ($('.custom-tooltip').is(':visible')) {
        //         $('.custom-tooltip').hide();
        //     }
        // });
    });

})(jQuery);

function allowSubmit(token) {
     //alert('thanks ' + document.getElementById('firstname').value);
    document.getElementById('contact-form__id').submit();
}

function getDates(startDate, endDate) {
    var dates = [],
         currentDate = startDate,
        addDays = function(days) {
            const date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
    while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
    }
    return dates;
}

function getEvents(date) {
    const selectedDate = new Date(date);
    const eventObject = [];
    // events.filter(function(itm){
    //     const dateRange = getDates(new Date(itm.FromDate), new Date(itm.ToDate));
    //     dateRange.forEach(function(dt) {
    //         if(dt.valueOf() === selectedDate.valueOf()) {
    //             return eventObject.push(itm);
    //         }
    //     });
    // });
    if(eventObject.length > 0) {
        $(".calendar-events").html(" ");
        eventObject.forEach(function (event) {
            const dataDate = event.FromDate;
            $(".calendar-events").append(
                "<div class='calendar-item'><div class='date' data-date='" + (dataDate.getMonth()+1) + '/' + dataDate.getDate() + '/' + dataDate.getFullYear() + "'>"
                + event.DisplayDate +  "</div>" +
                "<div class='headline'>"
                + event.Title + "</div>" +
                "<div class='description'>"
                + event.Description + "</div>" +
                "<div class='ical'>"
                + event.IcalLink + "</div></div>"
            );
        })
        $(".no-event").hide();
    } else {
        $(".no-event").show();
        $(".calendar-events").html(" ");
    }
}

function createCustomTooltip(event, selectedDate) {
    const hoverDate = new Date(selectedDate);
    const hovereventObject = [];
    // events.filter(function(itm){
    //     const dateRange = getDates(new Date(itm.FromDate), new Date(itm.ToDate));
    //     dateRange.forEach(function(dt) {
    //         if(dt.valueOf() === hoverDate.valueOf()) {
    //             return hovereventObject.push(itm);
    //         }
    //     });
    // });
    $(".custom-tooltip").hide();
    $(".custom-tooltip").html(" ");
    if(hovereventObject.length > 0) {
        hovereventObject.forEach(function (hoverEvent) {
            $(".custom-tooltip").append(
                "<span>" + hoverEvent.DisplayDate + "</span>" +
                "<h3>"+ hoverEvent.Title +"</h3>" +
                "<p>"+ hoverEvent.Description +"</p>"
            )
        });
        $(".custom-tooltip").css({top: event.offsetY, left: event.offsetX}).show();
    } else {
        $(".custom-tooltip").hide();
    }

}








(function ($) {
    $(document).ready(function () {

        /* actions before submitting crm form */
        $('.qtmanews__filters form').on('submit', function(e) {


            let startmonth = "";
            let startyear = "";
            let endmonth = "";
            let endyear = "";

            let startdate = $('input[name=startDate]');
            let enddate = $('input[name=endDate]');

            $('#startmonth option:selected').each(function () {
                startmonth = $('select[name=startmonth]').val();

            })
            $('#startyear option:selected').each(function () {
                startyear = $('select[name=startyear]').val();

            })
            $('#endmonth option:selected').each(function () {
                endmonth = $('select[name=endmonth]').val();

            })
            $('#endyear option:selected').each(function () {
                endyear = $('select[name=endyear]').val();

            })
            enddateval = endyear + '-' + endmonth + '-31';
            startdateval = startyear + '-' + startmonth + '-01';
            enddate.attr('value', '');
            startdate.attr('value', '');


            $('#startyear option:selected').each(function () {
                enddate.attr('value', enddateval);

            })

            $('#endyear option:selected').each(function () {
                startdate.attr('value', startdateval);

            })


            


            

            /* clean param to avoid value doubling */
            $categoryInput.attr('value', '');
            categories = '';

            $('input[name=other_language]:checked').each(function () {
                /* build category sting */
                languageCode = $(this).attr('languagecode');

                /* Check if subscription is selected */
                $('#selectFunction option:selected').each(function () {
                    $functionName = $(this);
                    categories += ((categories === '') ? '' : ';') + $functionName.val() + '_' + languageCode;
                });
                $('input[name=distributionlist]:checked').each(function () {
                    $distribuitionlist = $(this);
                    categories += ((categories === '') ? '' : ';') + $distribuitionlist.val() + '_' + languageCode;
                });
            });

            if (categories != '') {
                $categoryInput.attr('value', categories);
            }


        });
    });
})(jQuery);

